import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';

import {
  AccentedTableRow,
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';
import { Energiforbruk } from '../../../../../types/building';

interface EnergiVareProps {
  energiforbruk: Energiforbruk;
  totalOppvarmetBRA: number | undefined;
}
export const NettoEnergiBehovView: FC<EnergiVareProps> = ({ totalOppvarmetBRA, energiforbruk }) => {
  const { t } = useTranslation();

  const filteredEnergiBehov = {
    romoppvarming: energiforbruk.romoppvarming,
    varmtvann: energiforbruk.varmtvann,
    vifter: energiforbruk.vifter,
    pumper: energiforbruk.pumper,
    belysning: energiforbruk.belysning,
    tekniskutstyr: energiforbruk.teknisk_utstyr,
    total: energiforbruk.totalt_netto_energibehov
  };

  return (
    <StyledTable>
      <TableBody>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={3}>{t('register.summary.header.nettoEnergibehov')}</TableCell>
        </AccentedTableRow>
        <AccentedTableRow>
          <TableCell>{t('register.summary.result.energivare')}</TableCell>
          <LeftBorderCell>{t('register.summary.header.nettoEnergibehovPerYear')}</LeftBorderCell>
          <LeftBorderCell>{t('register.summary.header.spesifiktEnergibehov')}</LeftBorderCell>
        </AccentedTableRow>
        <AccentedTableRow>
          <TableCell />
          <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWh')}</LeftBorderCell>
          <LeftBorderCell>{t('expertToolsJSON.summary.suffix.kWhM2')}</LeftBorderCell>
        </AccentedTableRow>
        {Object.entries(filteredEnergiBehov).map(
          ([key, value]) =>
            value > 0 && (
              <TableRow key={key}>
                <TableCell>{t(`register.summary.result.${key}`)}</TableCell>
                <LeftBorderCell>{value.toFixed(1)}</LeftBorderCell>
                <LeftBorderCell>{totalOppvarmetBRA ? (value / totalOppvarmetBRA).toFixed(2) : '0.00'}</LeftBorderCell>
              </TableRow>
            )
        )}
      </TableBody>
    </StyledTable>
  );
};
